import { PolarisVizProvider as PolarisVizProvider$1 } from '@shopify/polaris-viz-core';
import { animated } from '@react-spring/web';
import { jsx } from 'react/jsx-runtime';

const PolarisVizProvider = ({
  themes,
  children,
  defaultTheme,
  onError
}) => {
  return /*#__PURE__*/jsx(PolarisVizProvider$1, {
    themes: themes,
    animated: animated,
    defaultTheme: defaultTheme,
    onError: onError,
    children: children
  });
};

export { PolarisVizProvider };
